(function () {
  'use strict';
  function init(root) {
    if (root.dataset.cvReady) return;
    var dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return; // Photo links still work.
    root.dataset.cvReady = 'true';
    var links = Array.from(root.querySelectorAll('[data-cv-culinary-open]'));
    var current = 0;
    var opener;
    function show(index) {
      current = (index + links.length) % links.length;
      var link = links[current];
      var img = dialog.querySelector('[data-cv-culinary-image]');
      img.src = link.href;
      img.alt = link.querySelector('img').alt;
      dialog.querySelector('[data-cv-culinary-title]').textContent = link.dataset.title;
      dialog.querySelector('[data-cv-culinary-caption]').textContent = link.dataset.caption;
      dialog.querySelector('[data-cv-culinary-count]').textContent = (current + 1) + ' / ' + links.length;
    }
    links.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        show(index);
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-cv-culinary-close]').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('[data-cv-culinary-prev]').addEventListener('click', function () { show(current - 1); });
    dialog.querySelector('[data-cv-culinary-next]').addEventListener('click', function () { show(current + 1); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('close', function () { if (opener) opener.focus({preventScroll:true}); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  }
  function boot() { document.querySelectorAll('[data-cv-culinary]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
